if (!customElements.get('product-header')) {
    customElements.define("product-header", class MainProduct extends HTMLElement {
        constructor() {
            super()
            this.media_indicator = this.querySelector('.selected-indicator')
            this.product_media_item = this.querySelectorAll('.product-media-item')
            this.rotationContainer = document.getElementById('product-media-rotation-container')
            this.swiperContainer = this.querySelector(`#${this.dataset.swiperId}`)
            this.initMediaButtons()
            this.listenerResize()
        }
        initMediaButtons() {
            const media_btn = Array.from(this.querySelectorAll('.media-btn'))
            this.activeItem = media_btn[0]
            if (media_btn.length < 1) return
            media_btn[0].classList.add('active')
            this.updateSelected()
            media_btn.forEach((item, index) => {
                item.addEventListener('click', () => {
                    item.classList.add('active')
                    $(media_btn).not(item).removeClass('active')
                    this.swiperContainer.slideTo(index)
                    this.activeItem = item
                    this.updateSelected(item)
                    this.selectViewMedia(item.dataset.type)
                })
            })
        }


        selectViewMedia(type) {
            if (type == 'rotation' && !this.rotationContainer.hasAttribute('open')) {
                this.rotationContainer.setAttribute('open', '')
            }
            // this.product_media_item.forEach(item => {
            //     if (item.dataset.id == type) {
            //         item.classList.add('active')
            //         $(this.product_media_item).not(item).removeClass('active')
            //     }
            //})
        }
        updateSelected(item = this.activeItem) {
            if (!item) return
            const { offsetLeft, offsetWidth } = item
            $(this.media_indicator).css({
                transform: 'translateX(' + offsetLeft + 'px)',
                width: offsetWidth + 'px'
            })
        }
        listenerResize() {
            this.swiperContainer.swiper.on("observerUpdate", () => {
                console.log('监测到DOM变化，更新Swiper')
            })
            window.addEventListener("resize", window._debounce(() => {
                this.updateSelected()
            }, 300))

        }

    })
}

